import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "react-bootstrap-icons";

export const COUNTRY_CODES = [
  { code: "us", name: "United States", dial: "+1" },
  // Add more here when needed
];

export type CountryCode = (typeof COUNTRY_CODES)[number];

interface Props {
  value: CountryCode;
  onChange?: (country: CountryCode) => void;
}

const PhonePrefixSelect: React.FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const flagImg = (code: string) => (
    <img
      src={`https://flagcdn.com/w20/${code}.png`}
      srcSet={`https://flagcdn.com/w40/${code}.png 2x`}
      alt={code}
      className="phone_prefix_flag"
    />
  );

  return (
    <div
      ref={ref}
      className="phone_prefix_select"
    >
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`phone_prefix_trigger ${open ? "active" : ""}`}
      >
        {flagImg(value.code)}

        <span className="phone_prefix_dial">
          {value.dial}
        </span>

        <ChevronDown
          size={12}
          className={`phone_prefix_icon ${open ? "rotate" : ""}`}
        />
      </button>

      {/* Dropdown */}
      {open && (
        <ul className="phone_prefix_dropdown">
          {COUNTRY_CODES.map((country) => (
            <li key={`${country.code}-${country.dial}`}>
              <button
                type="button"
                onClick={() => {
                  onChange?.(country);
                  setOpen(false);
                }}
                className={`flag-dropdown-select ${
                  value.code === country.code ? "active" : ""
                }`}
              >
                {flagImg(country.code)}

                <span className="country_name">
                  {country.name}
                </span>

                <span className="country_dial">
                  {country.dial}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PhonePrefixSelect;